import StringHelper from "../helpers/StringHelper";

export default {
	install(Vue) {
		Vue.prototype.$navigate = function navigate(obj) {
			const { name, params, cleanParams } = obj;

			if (cleanParams) {
				cleanParams.forEach(param => {
					if (params[param]) {
						params[param] = StringHelper.removeAccentuation(
							params[param]
						);
						params[param] = StringHelper.removeWhiteSpace(
							params[param]
						);
					}
				});
			}

			this.$router.push({ name, params });
		};

		Vue.prototype.$cleanParam = function clean(param) {
			if (typeof param === "string") {
				param = StringHelper.removeAccentuation(param);
				param = StringHelper.removeWhiteSpace(param);
			}

			return param;
		};
	}
};
